module.exports = __webpack_public_path__ + "static/img/3-4.f6a96f29.jpg";